import { css } from "lit";

import { registerStyles } from "./register-styles.js";

/**
 * Block-Vokabular der Startseite.
 *
 * Das Gemeinsame (Mono-Meta, Titel, Listen, Zeilen, Fokus) steht in
 * `common/styles/register-styles.ts` — Startseite und Fach-Seiten sollen als
 * eine Familie lesbar sein. Hier steht nur, was ein BLOCK zusätzlich braucht.
 * Blöcke werden durch Weißraum getrennt, Linien gibt es nur innerhalb von Listen.
 */
export const blockStyles = [
  registerStyles,
  css`
    :host {
      display: block;
      max-width: var(--portal-content-width);
      margin: 0 auto;
      padding: 0 var(--portal-gutter);
      color: var(--portal-ink);
      font-family: var(--portal-font-body);
      font-size: var(--portal-size-md);
      line-height: var(--portal-line-height);
    }

    /*
     * --- Anschlag: Blocküberschrift --------------------------------------
     * Die Größe entscheidet die SEITE, nicht der Block (Regel 1.2): Blockseiten
     * lassen den Default xl, Gegenstand-Seiten setzen am Host
     * --portal-h2-size: var(--portal-size-lg). Derselbe Block ist so auf /rat
     * lg und auf /bezirk/… xl, ohne es zu wissen.
     */
    h2 {
      margin: 0;
      font-family: var(--portal-font-display);
      font-stretch: var(--portal-display-stretch);
      font-weight: var(--portal-display-weight);
      font-size: var(--portal-h2-size, var(--portal-size-xl));
      line-height: 1.15;
      letter-spacing: -0.01em;
    }

    /*
     * Die Auswahl-Zeile: sichtbare Anwendung des Neutralitätsversprechens.
     * Wörtlich aus den Daten, kein Block ohne sie.
     */
    .auswahl {
      margin: var(--portal-space-3) 0 0;
      font-family: var(--portal-font-mono);
      font-size: var(--portal-size-meta);
      line-height: 1.45;
      color: var(--portal-ink-2);
      text-transform: uppercase;
      letter-spacing: var(--portal-tracking-caps);
    }

    /* Zwischenüberschrift einer Datumsgruppe (Block 2 und 4). */
    .gruppe-titel {
      margin: 0;
      padding: var(--portal-space-6) 0 var(--portal-space-2);
      font-family: var(--portal-font-mono);
      font-size: var(--portal-size-meta);
      font-weight: 500;
      color: var(--portal-ink-2);
      text-transform: uppercase;
      letter-spacing: var(--portal-tracking-caps);
    }
    .gruppe-titel:first-of-type {
      padding-top: var(--portal-space-4);
    }

    /* Titel in Teasern werden immer gekürzt — drei Zeilen. */
    .titel {
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }

    /*
     * Der Rückweg zur stadtweiten Sicht. Ein Textknopf, kein Button-Klotz:
     * Er ist der Ausgang aus einem Zustand, nicht die Hauptsache des Blocks.
     */
    .stadtweit {
      display: inline-block;
      background: none;
      border: none;
      padding: 0;
      margin-top: var(--portal-space-6);
      font-family: var(--portal-font-mono);
      font-size: var(--portal-size-sm);
      color: var(--portal-ink-2);
      cursor: pointer;
      text-decoration: underline;
    }
    /* Steht er neben einem weiterführenden Link, trennt sie ein Abstand. */
    .weiter + .stadtweit {
      margin-left: var(--portal-space-6);
    }
    .stadtweit:hover {
      color: var(--portal-akzent);
    }

    /* Weiterführender Link am Blockfuß. */
    .weiter {
      display: inline-block;
      margin-top: var(--portal-space-6);
      font-family: var(--portal-font-mono);
      font-size: var(--portal-size-sm);
      color: var(--portal-ink-2);
    }
    .weiter:hover {
      color: var(--portal-akzent);
    }
  `,
];
